export const defaultItemsSliderModelData = {
  isSliderInitialized: false,
  isTouched: false,
  touchX: null,
  disabledPrev: true,
  disabledNext: false,
  scrollItemIndex: 0
};

export const ActionType = {
  INIT_SLIDER: `INIT_SLIDER`,
  DESTROY_SLIDER: `DESTROY_SLIDER`,
  SLIDE_NEXT: `SLIDE_NEXT`,
  SLIDE_PREV: `SLIDE_PREV`,
  DISABLE_NAV_ITEM: `DISABLE_NAV_ITEM`,
  ENABLE_NAV_ITEM: `ENABLE_NAV_ITEM`,
};

export const TOUCH_THRESHOLD = 30;

export const NavDirection = {
  NEXT: `next`,
  PREV: `prev`
};
